export default function ApplicationsIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.66 5.51945L18.49 8.34945L15.66 11.1795L12.83 8.34945L15.66 5.51945ZM8 5.99945V9.99945H4V5.99945H8ZM18
 15.9995V19.9995H14V15.9995H18ZM8 15.9995V19.9995H4V15.9995H8ZM15.66 2.68945L10 8.33945L15.66 13.9995L21.32 8.33945L15.66 2.68945ZM10 
 3.99945H2V11.9995H10V3.99945ZM20 13.9995H12V21.9995H20V13.9995ZM10 13.9995H2V21.9995H10V13.9995Z"
        fill={color ? color : '#696D75'}
      />
    </svg>
  );
}
